(() => {
  const requests = new WeakMap();
  const refresh = async (host, variant) => {
    const content = host.querySelector('.lm-store-stock__content');
    const message = host.querySelector('[data-lm-stock-message]');
    requests.get(host)?.abort();
    if (!variant) {
      content.hidden = true;
      message.textContent = host.dataset.errorLabel;
      message.hidden = false;
      return;
    }
    const controller = new AbortController();
    requests.set(host, controller);
    const wasOpen = host.querySelector('details').open;
    host.setAttribute('aria-busy', 'true');
    content.hidden = true;
    message.hidden = false;
    message.textContent = host.dataset.loadingLabel;
    try {
      const url = new URL(host.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', String(variant.id));
      url.searchParams.set('section_id', 'lamaro-store-availability');
      const response = await fetch(url.toString(), {signal: controller.signal});
      if (!response.ok) throw new Error('availability');
      const documentResult = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = documentResult.querySelector('[data-lm-store-stock]');
      if (!replacement || replacement.dataset.variantId !== String(variant.id)) throw new Error('variant');
      if (controller.signal.aborted) return;
      host.innerHTML = replacement.innerHTML;
      host.dataset.variantId = String(variant.id);
      host.querySelector('details').open = wasOpen;
    } catch (error) {
      if (error.name === 'AbortError') return;
      content.hidden = true;
      message.textContent = host.dataset.errorLabel;
      message.hidden = false;
    } finally {
      if (requests.get(host) === controller) host.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('change', event => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    const host = form.parentElement.querySelector('[data-lm-store-stock]');
    if (!host) return;
    window.setTimeout(() => {
      const json = form.querySelector('[id^="VariantsJson-"]');
      if (!json) return;
      const variants = JSON.parse(json.textContent);
      const options = [...form.querySelectorAll('select[data-index], input[data-index]')].filter(input =>
        !['radio', 'checkbox'].includes(input.type) || input.checked
      );
      let variant = null;
      if (options.length) {
        variants.forEach(candidate => {
          if (options.every(input => candidate[input.dataset.index] === input.value)) variant = candidate;
        });
      } else {
        const selected = form.querySelector('[name="id"]');
        variant = variants.find(candidate => String(candidate.id) === selected?.value) || null;
      }
      refresh(host, variant);
    }, 0);
  });
})();
